import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=e5ded500&scoped=true"
import script from "./dept.vue?vue&type=script&lang=js"
export * from "./dept.vue?vue&type=script&lang=js"
import style0 from "./dept.vue?vue&type=style&index=0&id=e5ded500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ded500",
  null
  
)

export default component.exports